import { THEME_COLOR_MAP } from '@/utils/themeConfig'

export const applyTheme = (theme, colorMap = THEME_COLOR_MAP) => {
    if (!theme) {
        return
    }

    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('theme', theme)

    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    if (metaThemeColor && colorMap && colorMap[theme]) {
        metaThemeColor.setAttribute('content', colorMap[theme])
    }
}

export const initTheme = (defaultTheme = 'light', colorMap = THEME_COLOR_MAP) => {
    const storedTheme = localStorage.getItem('theme')
    const theme = storedTheme || defaultTheme
    applyTheme(theme, colorMap)
    return theme
}

export const switchTheme = (theme, colorMap = THEME_COLOR_MAP) => {
    applyTheme(theme, colorMap)
    return theme
}
